import axios from 'axios'
import { config, url } from '@/store'

const getUserOptionList = (params = {
  pagination: {
    currentPage: 1,
    perPage: 20
  },
  filter: {
    search: ''
  }
}) => {
  return axios.get(`${url}/users?expand=avatar,profile,department,groups&per-page=${params.pagination.perPage}&${params.filter.search}`, config)
}

const getRoleList = () => {
  return axios.get(`${url}/lists/user-roles`, config)
}

const getStatusList = () => {
  return axios.get(`${url}/statuses?fields=id,name`, config)
}

const getPositionList = async () => {
  const response = await axios.get(`${url}/positions?per-page=1`, config)
  return await axios.get(`${url}/positions?sort=-id&per-page=${response.headers['x-pagination-total-count']}`, config)
}

const getEmploymentList = () => {
  return axios.get(`${url}/employments?fields=id,name`, config)
}

const getScheduleList = () => {
  return axios.get(`${url}/schedules?fields=id,name`, config)
}

const getKinshipList = () => {
  return axios.get(`${url}/kinship?fields=id,name`, config)
}

const getDocumentTypes = () => {
  return axios.get(`${url}/document-types?fields=id,name`, config)
}

const getEducationTypes = () => {
  return axios.get(`${url}/education-types?fields=id,name`, config)
}

const getEducationDocumentList = () => {
  return axios.get(`${url}/education-documents?fields=id,name`, config)
}

const getSpecialities = () => {
  return axios.get(`${url}/education-specialities?fields=id,name`, config)
}

const getDepartmentList = () => {
  return axios.get(`${url}/departments?fields=id,name&per-page=99999`, config)
}

const getGroupList = () => {
  return axios.get(`${url}/groups?per-page=99999?fields=id,name,color&expand=users`, config)
}

const getTaskOptionList = () => {
  return axios.get(`${url}/tasks?fields=id,name,column_id&per-page=99999`, config)
}

const getTaskColumns = () => {
  return axios.get(`${url}/task-columns?sort=-id&per-page=99999`, config)
}

const getTaskProcessTypes = () => {
  return axios.get(`${url}/lists/task-process-types`, config)
}

const getApproveProcessTypes = () => {
  return axios.get(`${url}/lists/approve-process-types`, config)
}

export default {
  getUserOptionList,
  getRoleList,
  getStatusList,
  getPositionList,
  getEmploymentList,
  getScheduleList,
  getKinshipList,
  getDocumentTypes,
  getEducationTypes,
  getEducationDocumentList,
  getSpecialities,
  getDepartmentList,
  getGroupList,
  getTaskOptionList,
  getTaskColumns,
  getTaskProcessTypes,
  getApproveProcessTypes
}
